import { Injectable } from "@angular/core";
import { CountryType } from "./enums/enums";
import { TranslateService } from "@ngx-translate/core";
import {map} from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class CountriesService {

    readonly COUNTRY_ENUM_TRANSLATION_PREFIX: string = 'countryType_';
    constructor(private translate: TranslateService) {}

    public getCountryName(countryCode): Observable<CountryType> {
        if (CountryType.hasOwnProperty(countryCode)) {
            return this.translate.get(this.COUNTRY_ENUM_TRANSLATION_PREFIX + countryCode);
        } else {
            return countryCode;
        }
    }

    public getCountriesKeys() {
      return CountryType;
    }

    public getCountriesKeyValue() : Observable<{id: string, name: string}[]> {
        let countriesBeforeTranslate: string[] = [];
        for (let property in CountryType) {
            countriesBeforeTranslate.push(this.COUNTRY_ENUM_TRANSLATION_PREFIX + CountryType[property]);
        }

        return this.translate.get(countriesBeforeTranslate).pipe(map(translatedCountries => {
            const properties = [];
            for (let property in translatedCountries) {
                properties.push({id: property.replace(this.COUNTRY_ENUM_TRANSLATION_PREFIX, ''), name: translatedCountries[property]});
            }
            return properties;
        }));
    }
}
